<template>
  <el-row class="container">
    <el-col :span="3">
      <div>
        <el-button type="default" @click="goback" size="mini" class="mb-2" icon="el-icon-arrow-left">返回</el-button>
      </div>
      <el-tree class="filter-tree" highlight-current node-key="routeName" :current-node-key="$route.name" :data="mulu"
               default-expand-all @node-click="handleNodeClick" ref="tree"></el-tree>
    </el-col>
    <el-col :span="21">
      <span style="margin-left: 20px">
        <span v-if="sh_status">
          <el-button size="mini" type="success" @click="handleCheckApprove('check_yes')">审核通过</el-button>
          <el-button size="mini" type="danger" @click="handleCheckApprove('check_no')">审核不通过</el-button>
        </span>
        <span v-if="sp_status">
          <el-button size="mini" type="success" @click="handleCheckApprove('approve_yes')">审批通过</el-button>
          <el-button size="mini" type="danger" @click="handleCheckApprove('approve_no')">审批不通过</el-button>
        </span>
      </span>
      <h1>附件1 直观检查情况汇总</h1>
      <table>
        <tr>
          <td>检测内容</td>
          <td>关键项目A</td>
          <td>关键项目B</td>
          <td>关键项目C</td>
        </tr>
        <template v-for="(below,i) in belows">
          <tr :key="i">
            <td>{{ below.item1 }}</td>
            <td>{{ below.A }}</td>
            <td>{{ below.B }}</td>
            <td>{{ below.C }}</td>
          </tr>
        </template>
      </table>
      <br>
      <table>
        <tr>
          <td><h1>检测结果汇总及整改建议</h1></td>
        </tr>
        <tr>
          <td style="text-align: left" v-html="content">
          </td>
        </tr>
      </table>
    </el-col>
  </el-row>
</template>

<script>
import Vue from "vue";

export default {
  data() {
    return {
      project_id: '',
      site_id: '',
      employee_id: 0,
      site_type: '',
      zg_sh_id: 0,
      zg_sp_id: 0,
      sh_status: false,
      sp_status: false,
      belows: {},
      content: '',
      mulu: [
        {id: 1, label: '附件1', routeName: 'report_zg_fj1'},
        {id: 2, label: '附件2', routeName: 'report_zg_fj2'},
        {id: 3, label: '附件3', routeName: 'report_zg_fj3'},
        {id: 4, label: '意见', routeName: 'report_zg_yj'},
      ]
    }
  },
  methods: {
    goback() {
      this.$router.push({name: `site_${this.$route.params.site_type}_list`, params: this.$route.params})
    },
    async getData() {
      try {
        let res = await this.$Api.post('get_report_zg_fj1', {
          project_id: this.project_id,
          site_id: this.site_id,
          site_type: this.site_type
        })
        if (res) {
          this.belows = res.belows
          this.content = res.content
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    //审核审批
    async handleCheckApprove(opt) {
      try {
        await this.$Api.post('check_approve', {
          opt_type: opt,
          project_id: this.project_id,
          site_id: this.site_id,
          site_type: this.site_type,
          cma_zg: 'zg'
        })
        this.$message.success('操作成功')
        if (opt === 'check_yes' || opt === 'check_no') {
          this.sh_status = false
        } else if (opt === 'approve_yes' || opt === 'approve_no') {
          this.sp_status = false
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    //设置操作按钮的状态
    async setButtonStatus() {
      try {
        let res = await this.$Api.post('get_all_sh_spers', {
          project_id: this.project_id,
          site_id: this.site_id
        })
        if (res) {
          res.forEach(item => {
            if (item.zg_sh_id) {
              this.zg_sh_id = item.zg_sh_id
            }
            if (item.zg_sp_id) {
              this.zg_sp_id = item.zg_sp_id
            }
          })
          let res2 = await this.$Api.post('get_site_status', {
            project_id: this.project_id,
            site_id: this.site_id,
            site_type: this.site_type,
            status_type: 'zg'
          })
          if (res2) {
            if (res2 === '审核中' && this.employee_id === this.zg_sh_id) {
              this.sh_status = true
            } else if (res2 === '审批中' && this.employee_id === this.zg_sp_id) {
              this.sp_status = true
            } else {
              this.sh_status = false
              this.sp_status = false
            }
          }
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },

    handleNodeClick(data) {
      if (this.$route.name !== data.routeName) {
        this.$router.push({
          name: data.routeName,
          params: {project_id: this.project_id, site_id: this.site_id, site_type: this.site_type}
        })
      }
    }
  },
  async created() {
    this.project_id = this.$route.params.project_id
    this.site_id = this.$route.params.site_id
    this.site_type = this.$route.params.site_type
    this.employee_id = Vue.$Config.userinfo.employee_id
    await this.setButtonStatus()
    await this.getData()
  }
}
</script>

<style scoped>
.mb-2 {
  margin-bottom: 10px;
}

table {
  width: 100%;
}

table tr td:first-child {
  width: 20%;
}

table tr td h1 {
  font-size: 16px;
}

h1 {
  text-align: center;
}

table, table tr td {
  border: 1px solid black;
  border-collapse: collapse;
  text-align: center;
  vertical-align: middle !important;
  font-size: 18px;
}

table tr td {
  word-wrap: break-word;
  white-space: pre-wrap;
  word-break: break-all;
}

.filter-tree {
  margin-right: 10px;
}

::v-deep .el-tree-node__content {
  padding: 10px 0;
}
</style>
